<template>
    <div>
        <b-row>
            <b-col md="12" class="my-1">
                <h3 class="text-themecolor">Feedbackmeldingen</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <!-- User Interface controls -->
                        <b-row>
                            <b-col md="12" class="my-1">
                                <b-form-group class="mb-0">
                                    <b-input-group>
                                        <b-form-input v-model="filter" :placeholder="$t('datatables.zoeken')" ref='search' />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!-- User Interface controls -->
    
                        <!-- Main table element -->
                        <b-row>
                            <b-col md="12">
                                <b-table class="table-hover"
                                         show-empty 
                                         :items="feedback"  
                                         :empty-text="getEmptyText(count)" 
                                         :fields="fields" 
                                         :current-page="currentPage" 
                                         :per-page="perPage" 
                                         :filter="filter" 
                                         @filtered="onFiltered"
                                         :busy="count == -1">
                                    <template v-slot:cell(actions)="row">
                                        <b-button v-b-modal.modalfeedback variant="themecolor" size="m" @click.stop="loadModal(row.item)">
                                            <i class="fa fa-comment" aria-hidden="true"></i>
                                        </b-button>
                                    </template>
                                    <template v-slot:cell(dateCreated)="data">{{ data.item.dateCreated | datetime }}</template>
                                    <template v-slot:cell(message)="data">
                                        <div style="max-width:500px;">
                                            {{data.item.message}}
                                       </div>
                                    </template>
                                    <template v-slot:table-busy>
                                        <PreLoader/>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                        <!-- Main table element -->
    
                        <!-- Pagination controls -->
                        <b-row>
                            <b-col md="12" lg="5">
                                <b-form-group label-cols :label="$t('datatables.perpagina')">
                                    <b-form-select :options="pageOptions" v-model="perPage" />
                                </b-form-group>
                            </b-col>
                            <b-col md="12" lg="7">
                                <b-pagination :total-rows="count" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
                            </b-col>
                        </b-row>
                        <!-- Pagination controls -->
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Modal Component -->
        <b-modal id="modalfeedback" ref="feedback" :title="`Reactie feedback melding`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
            <b-form @submit="onSubmit" autocomplete="off">
                <!-- Form content -->
                <h3>Melding</h3>
                {{command.message}}
                <hr/>
                <b-textarea id="reactie" v-model="command.reactie" type="text" />
                <!-- Form content -->
                <hr />
                <!-- Submit controls -->
                <b-row>
                    <b-col md="12">
                        <b-button @click="$refs.feedback.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                        <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                    </b-col>
                </b-row>
                <!-- Submit controls -->
            </b-form>
        </b-modal>
        <!-- Modal Component -->
    </div>
    </template>
    
    <script>
    //Import store
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    
    //Import command
    import Command from './command'
    import PreLoader from '@/components/root/Preloader';
    import { getEmptyText } from '@/views/root/GetMessageTextHelper';
    
    export default {
        name: `feedback-index`,
        components: {PreLoader},
        data() {
            return {
                command: {},
                currentPage: 1,
                perPage: 50,
                pageOptions: [50, 100, 200],
                filter: null,
                count: -1
            }
        },
        computed: {
            fields() { 
                return [
                    {
                        key: 'klant.customerIdAndName',
                        label: 'Klant',
                        sortable: true
                    },
                    {
                        key: 'dateCreated',
                        label: 'Datum',
                        sortable: true
                    },
                    {
                        key: 'message',
                        label: 'Melding',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: this.$i18n.t('datatables.acties')
                    }
                ]
            },
            ...mapGetters ('fmmodule', ['feedback']),
        },
        methods: {
            ...mapActions('fmmodule', ['all', 'update']),
            onFiltered(filteredItems) {
                this.count = filteredItems.length;
                this.currentPage = 1
            },
            loadModal(item) {
                let vm = this;
                vm.$store.dispatch('errors/clearErrors');
                vm.command = new Command(item);
            },
            onSubmit(event) {
                event.preventDefault();
                let vm = this;
    
                let payload = {
                    resource: 'feedback',
                    path: vm.$route.path,
                    params: vm.command
                };
    
                let action = vm.command.id ? vm.update(payload) : vm.create(payload);

                action.then(() => {
                    vm.$store.dispatch('fmmodule/all', {resource: 'feedback'});
                    vm.$refs.feedback.hide();
                })
            },
            getEmptyText,
        },
        created() {
            let vm = this;
            vm.all({
                resource: 'feedback'
            })
            .then((data) => {
                vm.count = data.result.length;
            });
        },
        mounted() {
            let vm = this;
            vm.command = new Command();
        }
    }
    </script>
    